import api from "@/api";
import {
  removeAllNonNumericCharacters,
  removeLeading1OnPhoneNumberForClientUse,
} from "@/util.js";
import router from '@/router';

function executeReCaptcha() {
  return window.grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, {
    action: "storefront",
  });
}

const state = () => ({
  account: false,
  authenticate: false,
  activeComponent: "login",
  authorized:
    (sessionStorage.getItem("bnJzLXNlc3Npb24=") &&
      sessionStorage.getItem("cmVhbF91c2Vy") === "dHJ1ZQ==") ||
    "",
  email: null,
  showSMSRetryMessage: false,
  // suspectedBot: false,
});

const actions = {
  async fetchAccountStatus(
    { commit, dispatch },
    { country_code, phone, verification_code },
  ) {
    const res = await api({
      data: {
        country_code,
        phone_number: removeAllNonNumericCharacters(phone),
        verification_code,
      },
      method: "POST",
      url: "/user/phones/verification/confirm",
    });
    res.err
      ? res.err === "Wrong code. Please try again."
        ? commit("SHOW_SMS_RETRY_MESSAGE", true)
        : dispatch("error/showError", res.err, { root: true })
      : (dispatch("auth/setRegistrationStatus", res.info, { root: true }),
        dispatch("store/fetch", null, { root: true }));
  },
  async login({ commit, dispatch }, creds) {
    const res = await api({
      data: creds,
      method: "POST",
      url: "/users/login",
    });
    res.err
      ? dispatch("error/showError", res.err, { root: true })
      : (commit("user/INIT", res.info, { root: true }),
        commit("AUTH"),
        dispatch("store/fetch", null, { root: true }));
  },
  async logout({ commit, dispatch }) {
    await api({
      method: 'POST',
      url: '/123/users/logout',
    });
    await commit('LOGOUT');
    await dispatch('store/fetch', null, { root: true });
    commit('cart/CLEAR', null, { root: true });
    commit('orders/CLEAR', null, { root: true });
    commit('favorites/CLEAR', null, { root: true });
    commit('user/CLEAR', null, { root: true });

    if (router.currentRoute.path !== '/') {
      return router.push({ path: '/' });
    }
  },
  async register({ commit, dispatch }, data) {
    const res = await api({
      data: {
        ...data,
        phone: removeAllNonNumericCharacters(data.phone),
      },
      method: "POST",
      url: "/users/register",
    });

    /* sms used to be the final stage of registration. now that email and
     * password are final stage, "Wrong code..." is not relevent and
     * SHOW_SMS_RETRY_MESSAGE is not even used there.
     */

    res.err
      ? res.err === "Wrong code. Please try again."
        ? commit("SHOW_SMS_RETRY_MESSAGE", true)
        : dispatch("error/showError", res.err, { root: true })
      : (commit("user/INIT", res.info, { root: true }), commit("AUTH"));
  },
  requestPasswordRestore({ commit }, info) {
    api({
      data: info,
      method: "POST",
      url: "/users/restore_password_request",
    });
    commit("UPDATE", info.email);
  },
  async restorePassword({ dispatch }, info) {
    const data = await api({
      data: info,
      method: "POST",
      url: "/users/restore_password_action",
    });
    if (!data.err) {
      return;
    }
    dispatch("error/showError", data.err, { root: true });
  },
  // async sendVerificationCodeToPhone({ commit, dispatch }, creds) {
  async sendVerificationCodeToPhone({ dispatch }, creds) {
    const token = await executeReCaptcha();
    const res = await api({
      data: {
        ...creds,
        phone_number: removeAllNonNumericCharacters(creds.phone_number),
        check: token,
      },
      method: "POST",
      url: "/user/phones/verification/send",
    });
    // res.err
    //   ? res.err === "Wrong code. Please try again."
    //     ? commit("SUSPECTED_BOT", true)
    //     : dispatch("error/showError", res.err, { root: true })
    //   : (commit("user/INIT", res.info, { root: true }), commit("AUTH"));
    res.err && dispatch("error/showError", res.err, { root: true });
  },
  setRegistrationStatus({ commit, dispatch }, info) {
    commit("AUTH");
    if (info.reason === "NO_ACCOUNT") {
      return;
    }

    info.reason === "NCM_ACCOUNT"
      ? dispatch("auth/updateNCMAccountUser", info, { root: true })
      : commit("user/INIT", info, { root: true });
  },
  updateNCMAccountUser({ commit }, info) {
    commit("UPDATE_ACCOUNT", info.reason);
    commit(
      "user/UPDATE",
      {
        address: info.address,
        birthday: info.birthday,
        name: info.name,
        phone: removeLeading1OnPhoneNumberForClientUse(info.phone),
      },
      { root: true },
    );
  },
  async updateAndAuthenticateUser({ commit, dispatch }, info) {
    commit("UPDATE_ACCOUNT", false);
    commit("user/UPDATE", info, { root: true });
    commit("AUTH");
    const data = await api({
      data: info,
      method: "PUT",
      url: "/123/users",
    });
    data.err && dispatch("error/showError", data.err, { root: true });
  },
};

const getters = {
  isAuthenticated: (state) => {
    const { authorized } = state;
    return !!authorized;
  },
};

const mutations = {
  AUTH(state) {
    state.authorized =
      sessionStorage.getItem("bnJzLXNlc3Npb24=") &&
      sessionStorage.getItem("cmVhbF91c2Vy") === "dHJ1ZQ==";
  },
  LOGOUT(state) {
    sessionStorage.removeItem("bnJzLXNlc3Npb24="); // nrs-session
    sessionStorage.removeItem("cmVhbF91c2Vy"); // real_user
    state.authorized = "";
  },
  OPEN(state, bool) {
    state.authenticate = bool;
  },
  SET_ACTIVE_COMPONENT(state, component) {
    state.activeComponent = component;
  },
  SET_REGISTRATION_STATUS(state, status) {
    state.registered = status;
  },
  SHOW_SMS_RETRY_MESSAGE(state, bool) {
    state.showSMSRetryMessage = bool;
  },
  // SUSPECTED_BOT(state, bool) {
  //   state.suspectedBot = bool;
  // },
  UPDATE(state, email) {
    state.email = email;
  },
  UPDATE_ACCOUNT(state, account) {
    state.account = account === "NCM_ACCOUNT";
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
